export interface BorderRadius {
  xxxs: string
  xxs: string
  xs: string
  s: string
  m: string
  l: string
  round: string
}

export const BorderRadii: BorderRadius = {
  xxxs: '2px',
  xxs: '4px',
  xs: '8px',
  s: '12px',
  m: '14px',
  l: '16px',
  round: '50%',
}
